import { render, staticRenderFns } from "./HowToInstall.vue?vue&type=template&id=7c928d72&"
import script from "./HowToInstall.vue?vue&type=script&lang=js&"
export * from "./HowToInstall.vue?vue&type=script&lang=js&"
import style0 from "./HowToInstall.vue?vue&type=style&index=0&id=7c928d72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HowToInstall.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports